import React from 'react'
import PropTypes from 'prop-types'
import ImageFallback from 'Components/imagefallback/next_image'

const MaleDailyArticleCardTwo = ({ isMobile, image, title, url, category }) => {
  const device = isMobile ? 'mobile' : 'desktop'
  return (
    <>
      <a className="article-style-two" href={url}>
        <div className={`article-style-two__image article-style-two__image--${device}`}>
          <ImageFallback
            objectFit="cover"
            alt={title}
            src={image || process.env.NEXT_PUBLIC_S3_IMAGE_BROKEN_SQUARE}
            fallbackSrc={process.env.NEXT_PUBLIC_S3_IMAGE_BROKEN}
            quality={100}
            width={400}
            height={400}
          />
        </div>
        <div className="article-style-two__text">
          <div className="article-style-two__category fd-body-sm-regular">
            {category?.replace(/_/gi, ' ')}
          </div>
          <div className="article-style-two__title fd-heading-4">{title}</div>
        </div>
      </a>
      <style jsx>
        {`
          .article-style-two {
            display: flex;
            flex-direction: column;
            gap: 20px;
            text-decoration: none;
          }

          .article-style-two__text {
            display: flex;
            flex-direction: column;
            gap: 8px;
          }

          .article-style-two__category {
            color: var(--text-sub);
            text-transform: capitalize;
          }

          .article-style-two__title {
            color: var(--text-default-inverse);
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 4;
            -webkit-box-orient: vertical;
            word-break: break-word;
          }

          .article-style-two__title:hover {
            text-decoration: underline;
          }

          .article-style-two__image {
            height: 100%;
            max-height: 240px;
            aspect-ratio: 1/1;
          }

          .article-style-two__image--mobile {
            max-height: 120px;
          }
        `}
      </style>
    </>
  )
}

MaleDailyArticleCardTwo.propTypes = {
  image: PropTypes.string,
  title: PropTypes.string,
  url: PropTypes.string,
  category: PropTypes.string,
  isMobile: PropTypes.bool,
}

export default MaleDailyArticleCardTwo
